import { useState } from 'react';
import { FiAlertTriangle, FiTrash2, FiX } from 'react-icons/fi';
import './ConfirmModal.css';

const ConfirmModal = ({ title, message, onConfirm, onCancel, type = 'warning', confirmText = 'დადასტურება', cancelText = 'გაუქმება' }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (loading) return;
    setLoading(true);
    try {
      await onConfirm();
    } catch {
      setLoading(false);
    }
  };

  return (
    <div className="confirm-overlay" onClick={loading ? undefined : onCancel}>
      <div className="confirm-box" onClick={(e) => e.stopPropagation()}>
        <div className={`confirm-icon-wrap ${type}`}>
          {type === 'delete' ? <FiTrash2 /> : <FiAlertTriangle />}
        </div>
        <h3 className="confirm-title">{title}</h3>
        <p className="confirm-msg">{message.split('\n').map((line, i) => <span key={i}>{line}<br/></span>)}</p>
        <div className="confirm-btns">
          <button className="confirm-cancel" onClick={onCancel} disabled={loading}>{cancelText}</button>
          <button className={`confirm-ok ${type}`} onClick={handleConfirm} disabled={loading}>
            {loading ? 'იტვირთება...' : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
